import apiClient from "./apiClient";

export const getRiskAppetite = () => apiClient.get("/risk-appetite");
export const createRiskAppetite = (payload) => apiClient.post("/risk-appetite", payload);
export const updateRiskAppetite = (id, payload) => apiClient.patch(`/risk-appetite/${id}`, payload);
export const deleteRiskAppetite = (id) => apiClient.delete(`/risk-appetite/${id}`);
